import { Link } from 'react-router-dom';
import { Mail, MapPin, Phone } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_armag-rebuild/artifacts/c29nzccu_cropped-Armageddon-Boats-Logo-300x284.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white" data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link to="/" className="mb-6 inline-block">
              <img 
                src={LOGO_URL} 
                alt="Armageddon Boats" 
                className="h-16 w-auto brightness-0 invert"
              />
            </Link>
            <p className="text-slate-400 leading-relaxed mb-6 max-w-md">
              Building Alaska's toughest custom aluminum boats since day one. 
              Commercial-grade quality that outlasts generations.
            </p>
            <p className="font-heading text-xl text-orange-500 uppercase tracking-wide">
              Built to Outlast You
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg font-bold uppercase tracking-wide mb-6">
              Quick Links
            </h4>
            <nav className="flex flex-col gap-3">
              <Link to="/" className="text-slate-400 hover:text-orange-500 transition-colors">
                Home
              </Link>
              <Link to="/models" className="text-slate-400 hover:text-orange-500 transition-colors">
                Boat Models
              </Link>
              <Link to="/about" className="text-slate-400 hover:text-orange-500 transition-colors">
                About Us
              </Link>
              <Link to="/gallery" className="text-slate-400 hover:text-orange-500 transition-colors">
                Gallery
              </Link>
              <Link to="/contact" className="text-slate-400 hover:text-orange-500 transition-colors">
                Contact
              </Link>
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-lg font-bold uppercase tracking-wide mb-6">
              Contact Us
            </h4>
            <div className="flex flex-col gap-4">
              <a 
                href="tel:907-415-9639" 
                className="flex items-center gap-3 text-slate-400 hover:text-orange-500 transition-colors"
              >
                <Phone className="w-5 h-5" />
                907-415-9639
              </a>
              <a 
                href="mailto:akskiffs@gmail.com" 
                className="flex items-center gap-3 text-slate-400 hover:text-orange-500 transition-colors"
              >
                <Mail className="w-5 h-5" />
                akskiffs@gmail.com
              </a>
              <div className="flex items-center gap-3 text-slate-400">
                <MapPin className="w-5 h-5" />
                Kenny Lake, AK
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            &copy; {currentYear} Armageddon Boats. All rights reserved.
          </p>
          <p className="text-slate-500 text-sm">
            Handcrafted in Alaska with precision and integrity.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
